import { render, staticRenderFns } from "./User_PAW_new.vue?vue&type=template&id=267e7a7c&scoped=true&"
import script from "./User_PAW_new.vue?vue&type=script&lang=js&"
export * from "./User_PAW_new.vue?vue&type=script&lang=js&"
import style0 from "./User_PAW_new.vue?vue&type=style&index=0&id=267e7a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267e7a7c",
  null
  
)

export default component.exports